import React, { useState } from 'react'
import { PeriodCategoryComponent } from '../Components/Category/PeriodCategoryComponent';
import { ObjectInstanceCalendarComponent } from '../Components/ObjectInstatnceCalendar/ObjectInstanceCalendarComponent';

export const ObjectInstanceCalendar = ({setLoading,showMessage}) => {
        // ======================================================================
        const [view, setView] = useState('Category');
        const [categoryId, setCategoryId] = useState();
        const [categoryTitle, setCategoryTitle] = useState();
        // ======================================================================
  return (
      <>
               {view === "Category" ?
                   <PeriodCategoryComponent
                       setLoading={setLoading}
                       showMessage={showMessage}
                       onClickItems={(id, title) => {
                           setCategoryId(id);
                           setCategoryTitle(title);
                           setView("Search");
                       }}
                   />
                   : <></>}
               {view == "Search" ?
                   <ObjectInstanceCalendarComponent
                       setLoading={setLoading}
                       showMessage={showMessage}
                       categoryId={categoryId}
                       onBackClick={(e) => {
                           setView("Category");
                       }}
                   /> : <></>
               }
           </>
  )
}


